import { Helmet } from "react-helmet-async";
import FunnelLayout from "@/v2/components/FunnelLayout";

const TerminiCondizioni = () => {
  return (
    <>
      <Helmet>
        <title>Termini e Condizioni - Progetto Startup</title>
        <meta name="description" content="Termini e condizioni di utilizzo dei servizi Progetto Startup: Proof, Reality Check, pagamenti, rimborsi e responsabilità." />
        <link rel="canonical" href="https://progettostartup.com/termini-e-condizioni" />
        <meta property="og:title" content="Termini e Condizioni - Progetto Startup" />
        <meta property="og:description" content="Termini di utilizzo dei servizi Progetto Startup: Proof, Reality Check, pagamenti, rimborsi e responsabilità." />
        <meta property="og:url" content="https://progettostartup.com/termini-e-condizioni" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Termini e Condizioni - Progetto Startup" />
        <meta name="twitter:description" content="Termini di utilizzo dei servizi Progetto Startup: Proof, Reality Check, pagamenti, rimborsi e responsabilità." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <FunnelLayout>
        <div className="max-w-3xl mx-auto">
          <article className="prose prose-invert max-w-none text-slate-300">
            <h1 className="text-white text-4xl font-bold mb-2">Termini e Condizioni di Utilizzo</h1>
            <p className="text-slate-500 mb-8">Ultimo aggiornamento: Luglio 2026</p>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">1. Oggetto</h2>
              <p>I presenti Termini regolano l'utilizzo del sito progettostartup.com e dei servizi collegati: Reality Check (analisi AI dell'idea imprenditoriale) e Sprint 48h (programma strutturato di validazione), inclusi i relativi contenuti digitali e strumenti interattivi.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">2. Titolare</h2>
              <p className="mb-2"><strong>Federico Piccinini Group</strong></p>
              <p className="mb-2">REA 226475</p>
              <p className="mb-2">
                <a href="mailto:ciao@progettostartup.com" className="text-orange-400 hover:text-orange-300">ciao@progettostartup.com</a>
              </p>
              <p>Italia</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">3. Registrazione e account</h2>
              <p>Per accedere allo Sprint 48h e ai contenuti premium è necessario creare un account. L'utente è responsabile della riservatezza delle proprie credenziali.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">4. Contenuti digitali</h2>
              <p className="mb-2">Tutti i materiali (video, PDF, testi, modelli, strumenti) sono protetti da copyright.</p>
              <p>È vietata la distribuzione o condivisione non autorizzata.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">5. Uso consentito</h2>
              <p className="mb-2">L'utente si impegna a:</p>
              <ul className="space-y-2">
                <li>Non utilizzare il sito per scopi illeciti</li>
                <li>Non interferire con i servizi o tentare accessi non autorizzati</li>
                <li>Non copiare o vendere contenuti senza permesso scritto</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">6. Acquisti e pagamenti</h2>
              <ul className="space-y-2">
                <li>I prezzi sono indicati in euro, IVA inclusa se applicabile</li>
                <li>L'accesso allo Sprint è personale e non trasferibile</li>
                <li>I pagamenti sono gestiti da Stripe in modo sicuro</li>
                <li>Non è previsto il diritto di recesso per contenuti digitali già fruiti (art. 59 Codice del Consumo)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">7. Esclusione di responsabilità</h2>
              <p className="mb-2">Progetto Startup fornisce formazione e strumenti, ma non garantisce risultati economici.</p>
              <p>Ogni attività imprenditoriale presenta rischi.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">8. Modifiche ai servizi</h2>
              <p>Possiamo aggiornare i contenuti, modificare funzioni o interrompere parti del servizio, con preavviso ragionevole quando possibile.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">9. Cancellazione account</h2>
              <p>
                L'utente può richiedere la cancellazione dell'account e dei dati personali via email:{" "}
                <a href="mailto:ciao@progettostartup.com" className="text-orange-400 hover:text-orange-300">ciao@progettostartup.com</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-slate-200 text-2xl font-semibold mb-4">10. Foro competente</h2>
              <p>Per eventuali controversie è competente il foro del luogo di residenza dell'utente (consumatori) o Milano/Bologna per rapporti professionali.</p>
            </section>
          </article>
        </div>
      </FunnelLayout>
    </>
  );
};

export default TerminiCondizioni;
